module.exports = __webpack_public_path__ + "static/media/maxbountyreferral-728x90.b8a61c93.jpg";